import React, { Component } from "react";
import { Panel } from "primereact/panel";
import moment from "moment-jalaali";
import { AutoComplete } from 'primereact/autocomplete';
import { ToggleButton } from 'primereact/togglebutton';
import Server from "../Server.js";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { SelectButton } from "primereact/selectbutton";
import { Tag } from "primereact/tag";
import { connect } from "react-redux";
import { Loader } from "rsuite";
import { Toast } from "primereact/toast";

class TurnRating extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.toast = React.createRef();
    this.CreateForm = this.CreateForm.bind(this);
    this.onHideFormsDialog = this.onHideFormsDialog.bind(this);
    this.SetEvent = this.SetEvent.bind(this);
    this.state = {
      Date: moment(),
      layout: "list",
      name: "",
      Type: "1",
      mobile: "",
      nationalCode: "",
      Settings: {},
      CodeFile: [],
      selectedDay: [],
      reservedDays: [],
      Time: "morning",
      CounterList: [],
      CounterListLength: 0,
      sendSms: true,
      mounth: ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"],
      key: ["one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten", "eleven", "toelve"],
      Mounth: {}
    };
  }
  isMobile() {
    if (window.innerWidth <= 768) {
      this.setState({
        isMobile: true,
      });
    }
  }
  componentDidMount() {
    this.isMobile();
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1,
    });
    let that = this;
    let SCallBack = function (response) {
      that.setState({
        user_Id: response.data.authData.userId,
        loading: 0,
      });
      that.getTurnRateSettings();
      
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack);
  }
  SetEvent() {
    let that = this;
    let param = {
      mobile: this.state.mobile,
      name: this.state.name,
      nationalCode: this.state.nationalCode,
      Counter: this.state.Counter,
      settingId: this.state.Settings._id,
      selectedDay: this.state.selectedDay,
      Time: this.state.Time,
      _id: this.state.selectedId
    };
    if(this.state.selectedDay.length ==0){
      this.toast.current.show({
        severity: "warn",
        summary: "",
        detail: "حداقل یک روز را انتخاب کنید",
        life: 3000,
      });
      return;
    }
    if(!this.state.Time){
      this.toast.current.show({
        severity: "warn",
        summary: "",
        detail: "نوبت را انتخاب کنید",
        life: 3000,
      });
      return;
    }
    if(!this.state.name){
      this.toast.current.show({
        severity: "warn",
        summary: "",
        detail: "نام را وارد کنید",
        life: 3000,
      });
      return;
    }
    if(!this.state.mobile){
      this.toast.current.show({
        severity: "warn",
        summary: "",
        detail: "موبایل را وارد کنید",
        life: 3000,
      });
      return;
    }
    if(!this.state.nationalCode){
      this.toast.current.show({
        severity: "warn",
        summary: "",
        detail: "کد ملی را وارد کنید",
        life: 3000,
      });
      return;
    }
    this.setState({
      HasErrorForMaps: null,
      loading: 1,
    });
    let SCallBack = function (response) {
      that.toast.current.show({
        severity: "success",
        summary: "",
        detail: "عملیات با موفقیت انجام شد",
        life: 3000,
      });
      that.setState({
        loading: false,
        visibleManageField: false,
      });
      that.getTurnRate();
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
      that.toast.current.show({
        severity: "error",
        summary: "خطای سرور",
        detail: "عملیات انجام نشد",
        life: 3000,
      });
    };
    this.Server.send("AdminApi/setTurnRate", param, SCallBack, ECallBack);
  }
  CreateForm() {
    this.setState({
      selectedId: null,
      visibleManageField: true,
      name: "",
      mobile: "",
      nationalCode: "",
      Date: moment(),
      Time: "morning",
      Type: "credit",
      selectedDay: [],
      originalSelectedDay: [],
      CounterList: [],
      CounterListLength: 0,
      Counter: null,
      sendSms: true,
    },()=>{
      this.GetTurnRatesReserved();
    });
  }
  onHideFormsDialog(event) {
    this.setState({
      visibleManageField: false,
      selectedId: null,
      selectedDay: [],
      CounterList: [],
      CounterListLength: 0,
      originalSelectedDay: []
    });
  }
  selectedComponentChange(value) {
    let that = this;
    this.setState({
      selectedId: value._id,
      selectedDay: value.selectedDay ? value.selectedDay.slice(0) : [],
      originalSelectedDay: value.selectedDay ? value.selectedDay.slice(0) : [],
      name: value.name,
      mobile: value.mobile,
      nationalCode: value.nationalCode,
      Time: value.Time,
      Counter: value.Counter,
      visibleManageField: true
    },()=>{
      this.getDayTurns(value.selectedDay||[]);
      this.GetTurnRatesReserved();
    });
  }
  getTurnRateSettings() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      year: moment(new Date()).local("fa").format("jYYYY"),
      systemId : this.props.systemId
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        Settings: response.data.result[0] || {},
      });
      //if(response.data.result[0] && response.data.result[0]._id)
      that.setState({
        loading: 0,
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("AdminApi/GetTUrnRateLists", param, SCallBack, ECallBack);
  }

  GetTurnRatesReserved() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      settingId: this.state.Settings._id,
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.GenerateReserveDetails(response.data.result[0])
      that.setState({
        loading: 0
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("AdminApi/GetTurnRatesReserved", param, SCallBack, ECallBack);
  }

  GenerateReserveDetails(response) {
    let that = this;
      const reserved = response.reserved;
      const reservedDays = [];
      reserved.map((rrr)=>{
        for(let day of rrr.selectedDay){
          reservedDays.push(day)
        }
      })
      let Mounth = {
        one: [],
        two: [],
        three: [],
        four: [],
        five: [],
        six: [],
        seven: [],
        eight: [],
        nine: [],
        ten: [],
        eleven: [],
        toelve: []
      };
      let week = ["یکشنبه", "دوشنبه", "سه شنبه", "چهارشنبه", "پنج شنبه", "جمعه", "شنبه"];
      for (let item of response.records) {
        let index = parseInt(item.day.split("_")[1]) - 1
        item.Mounth = that.state.mounth[index];
        item.MounthNum = parseInt(item.day.split("_")[1]);
        item.Day = item.day.split("_")[2];
        item.Year = item.day.split("_")[0];
        item.value = item.day;
        item.label = item.Day;
        if (item.MounthNum == 1)
          Mounth.one.push(item)
        if (item.MounthNum == 2)
          Mounth.two.push(item)
        if (item.MounthNum == 3)
          Mounth.three.push(item)
        if (item.MounthNum == 4)
          Mounth.four.push(item)
        if (item.MounthNum == 5)
          Mounth.five.push(item)
        if (item.MounthNum == 6)
          Mounth.six.push(item)
        if (item.MounthNum == 7)
          Mounth.seven.push(item)
        if (item.MounthNum == 8)
          Mounth.eight.push(item)
        if (item.MounthNum == 9)
          Mounth.nine.push(item)
        if (item.MounthNum == 10)
          Mounth.ten.push(item)
        if (item.MounthNum == 11)
          Mounth.eleven.push(item)
        if (item.MounthNum == 12)
          Mounth.toelve.push(item)
      }
      let showDiv = 0;
      if (Mounth.toelve.length > 0)
        showDiv = 11
      if (Mounth.eleven.length > 0)
        showDiv = 10
      if (Mounth.ten.length > 0)
        showDiv = 9
      if (Mounth.nine.length > 0)
        showDiv = 8
      if (Mounth.eight.length > 0)
        showDiv = 7
      if (Mounth.seven.length > 0)
        showDiv = 6
      if (Mounth.six.length > 0)
        showDiv = 5
      if (Mounth.five.length > 0)
        showDiv = 4
      if (Mounth.four.length > 0)
        showDiv = 3
      if (Mounth.three.length > 0)
        showDiv = 2
      if (Mounth.two.length > 0)
        showDiv = 1
      if (Mounth.one.length > 0)
        showDiv = 0
      that.setState({
        loading: 0,
        showDiv: showDiv,
        Mounth: Mounth,
        Allow: true,
        reservedDays: reservedDays
      })

  }

  
  getTurnRate(_id) {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      settingId: this.state.Settings._id,
      mobile: this.state.SearchValue
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        GridDataFields: response.data.result,
      });
      that.setState({
        loading: 0,
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("AdminApi/getTurnRate", param, SCallBack, ECallBack);
  }

  
  itemTemplate(brand) {
    return (
      <div className="p-clearfix" style={{ direction: 'rtl', maxWidth: '100%' }} >
        <div style={{ margin: '10px 10px 0 0' }} className="row" _id={brand._id} >
          <div className="col-8" _id={brand._id} style={{ textAlign: 'right' }}>
            <span className="iranyekanwebregular" style={{ textAlign: 'right', overflow: 'hidden' }} _id={brand._id} >
              <span style={{ whiteSpace: 'pre-wrap' }} _id={brand._id}>{brand.name}</span><br />
            </span>
          </div>

        </div>
      </div>
    );
  }
  
  suggestBrands(event) {
    let that = this;
    this.setState({ brand: event.query, Count: 0 });
    let param = {
        system:this.state.managerSystem ? this.state.managerSystem : null,
        isMainSystem: true,
        title: event.query,
        table: "TurnRatesReserved",
        name: ["name", "mobile", "nationalCode"]
      };
   
    let SCallBack = function (response) {
      let brandSuggestions = [];
      response.data.result.reverse().map(function (v, i) {
        brandSuggestions.push({ mobile: v.mobile, name: v.name })
      })
      that.setState({ brandSuggestions: brandSuggestions });
    };

    let ECallBack = function (error) {

    }
    that.Server.send("AdminApi/searchItems", param, SCallBack, ECallBack)


  }

  
  getDayTurns(selectedDay) {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      selectedDay: selectedDay
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      const Counter = [];
      let count = 0;
      const usersList = that.state.Settings.usersList;
      for(let uuu of usersList){
        Counter[count] = [];
        for(let i=0;i<response.data.result.length;i++){
          const data = response.data.result[i];
          if(uuu.username === data.user[0].username){
            Counter[count].push({
              username: data.user[0].username,
              name: data.user[0].name,
              time: data.Time
            })
          }
        }
        count++;
      }
      for(let i=0;i<Counter.length;i++){
        for(let j=0; j<Counter[i].length;j++){
          if(Counter[i][j].time === "morning"){
            Counter[i].morning = (Counter[i].morning|| 0)+1;
          }
          if(Counter[i][j].time === "evening"){
            Counter[i].evening = (Counter[i].evening|| 0)+1;
          }
          if(Counter[i][j].time === "night"){
            Counter[i].night = (Counter[i].night || 0)+1;
          }
        }
      }

      that.setState({
        loading: 0,
        CounterListLength : response.data.result.length,
        CounterList : Counter
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("AdminApi/getDayTurnRates", param, SCallBack, ECallBack);
  }
  

  render() {
    
    const CounterTemplate = (rowData, props) => {
      console.log(this.state)
      let title = "-"
      this.state.Settings && this.state.Settings.usersList && this.state.Settings.usersList.map((item)=>{
        if(item.username == rowData.Counter){
          title = item.title;
        }
      })
      return (
        <span>{title}</span>
      )
      } 
    const DateTemplate = (rowData, props) => {
      return (
        <div style={{direction:'ltr', display:'flex',flexDirection:'column',alignItems:'center'}}>
          {
          rowData.selectedDay.map((item)=>{
            return (
              <Tag
              style={{marginBottom:5}}
              severity="success"
              value={
                <span>{item}</span>
              }
            ></Tag>
            )
          })
          }
        </div>
      )
      } 
    const TimeTemplate = (rowData, props) => {
      if (rowData.Time == "morning") {
        return (
          <Tag
              severity="primary"
              value={
                <span>صبح</span>
              }
            ></Tag>
        );
      } else if(rowData.Time == "evening"){
        return (
          <Tag
              severity="info"
              value={
                <span>عصر</span>
              }
            ></Tag>
        );
      }else{
        return (
          <Tag
              severity="warning"
              value={
                <span>شب</span>
              }
            ></Tag>
        );
      }
    };
    const doneTemplate = (rowData, props) => {
      if (rowData.done) {
        return (
          <div>
            <Tag
              severity="success"
              value={
                <div
                  style={{
                    width: 70,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <i className="fa fa-thumbs-up"></i>
                  <span>انجام شده</span>
                </div>
              }
            ></Tag>
          </div>
        );
      } else {
        return (
          <div>
            <Tag
              severity="info"
              value={
                <div
                  style={{
                    width: 70,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <i className="fas fa-spinner fa-pulse"></i>
                  <span>در حال انجام</span>
                </div>
              }
            ></Tag>
          </div>
        );
      }
    };

    const footer = (
      <div>
        <button
          className="btn btn-primary irsans"
          onClick={this.SetEvent}
          style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}
        >
          {" "}
          اعمال{" "}
        </button>
      </div>
    );
    
    // {
    //   value: "morning",
    //   label: "صبح",
    // },
    // {
    //   value: "evening",
    //   label: "عصر",
    // },
    const TimeOptions = [];
    if(this.state.Settings.isMorning){
      TimeOptions.push(
        {
            value: "morning",
            label: "صبح",
        }
      )
    }
    if(this.state.Settings.isEvening){
      TimeOptions.push(
        {
            value: "evening",
            label: "عصر",
        }
      )
    }
    if(this.state.Settings.isNight){
      TimeOptions.push(
        {
            value: "night",
            label: "شب",
        }
      )
    }
    const tagStatus = ["primary","success","warning","info","danger"]
    return (
      <div style={{ direction: "rtl" }}>
        <Toast
          ref={this.toast}
          position="top-left"
          style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
        />
        {this.state.loading == 1 && (
          <div
            style={{
              position: "fixed",
              zIndex: 2000,
              top: 10,
              left: 15,
              backgroundColor: "#e89f31",
              padding: "2px 20px",
            }}
          >
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        )}
        <div className="row justify-content-center mt-2">
          <div className="col-12" style={{ background: "#fff" }}>
            <Panel
              header="رویدادها"
              style={{ textAlign: "right", fontFamily: "yekan" }}
            >
              <div className='row' >
                <div className="col-lg-6 col-12 mb-5" style={{ background: '#fff', textAlign: 'right', marginTop: 20 }}>
                  <AutoComplete placeholder="بخشی از نام / شماره موبایل / کد ملی مراجعه کننده  را جستجو کنید" style={{ width: "100%" }} onChange={(event) => { this.setState({ searchName: event.value, SearchValue: null });
                    
                }} itemTemplate={this.itemTemplate.bind(this)} value={this.state.searchName} onSelect={(event) => {
                    this.setState({
                      limit: 10,
                      skip: 0,
                      count: 0,
                      first: 0,
                      SearchValue: event.value.mobile,
                      searchName: event.value.name
                    }, ()=>{

                      this.getTurnRate();
                    })
                  }} suggestions={this.state.brandSuggestions} completeMethod={this.suggestBrands.bind(this)} />

                </div>
                <div className="col-lg-6 col-12 mb-5" style={{ background: '#fff', textAlign: 'right', marginTop: 20 }}>
                <button
                    className="btn btn-info irsans"
                    onClick={() => {
                      this.setState({
                        limit: 10,
                        skip: 0,
                        count: 0,
                        first: 0,
                      },()=>{
                        this.getTurnRate();

                      })
                    }}
                  >
                    جستجو
                  </button>
                </div>
                </div>

              <div className="row">
                <div className="col-6" style={{ textAlign: "right" }}>
                  <button
                    className="btn btn-primary irsans"
                    onClick={this.CreateForm}
                    style={{
                      width: "200px",
                      marginTop: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    ایجاد نوبت جدید
                  </button>
                </div>
              </div>

              <DataTable
                responsive
                value={this.state.GridDataFields}
                selectionMode="single"
                stripedRows
                selection={this.state.selectedComponent}
                onSelectionChange={(e) => this.selectedComponentChange(e.value)}
              >
                <Column
                  field="name"
                  header="نام"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="mobile"
                  header="موبایل"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="Date"
                  header="تاریخ"
                  className="irsans"
                  style={{ textAlign: "right" }}
                  body={DateTemplate}
                />
                <Column
                  field="Time"
                  header="زمان"
                  className="irsans"
                  style={{ textAlign: "right" }}
                  body={TimeTemplate}
                />
                <Column
                  field="name"
                  header="نام"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="nationalCode"
                  header="کد ملی"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="Counter"
                  header="کاربر (باجه)"
                  className="irsans"
                  style={{ textAlign: "right" }}
                  body={CounterTemplate}
                />
              </DataTable>
            </Panel>
          </div>
        </div>

        <Dialog
          header={this.state.selectedId ? "مشاهده" : "ایجاد نوبت جدید"}
          visible={this.state.visibleManageField}
          footer={footer}
          minY={70}
          onHide={this.onHideFormsDialog}
          maximizable={true}
          maximized={false}
        >
          <form>
            

          <div className="no-scroll-bar" style={{ display: 'inline', flexWrap: 'wrap', overflow: 'auto', direction: 'rtl' }} >
              {this.state.mounth.map((item, index) => {

                let key = this.state.key[index];
                let prev = index - 1;
                let next = index + 1;
                return (
                  this.state.Mounth && this.state.showDiv == index &&
                  <div style={{ border: '1px solid #eee', textAlign: 'center', padding: 10, position: 'relative',minHeight:270 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }} >
                      {index != 0 ?
                        <div><i class="fas fa-angle-double-right" onClick={() => {
                          this.setState({
                            showDiv: prev
                          })
                        }} /></div>
                        :
                        <div><i /></div>
                      }
                      <div><p className="iranyekanwebmedium" style={{ textAlign: 'center' }}>{this.state.mounth[index]}</p>
                      </div>
                      {index != 11 ?
                        <div><i class="fas fa-angle-double-left" onClick={() => {
                          this.setState({
                            showDiv: next
                          })
                        }} /></div>
                        :
                        <div><i /></div>
                      }
                    </div>
                    <div style={{display:'flex',justifyContent:'center'}}>

                    <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', maxWidth:300 }}>
                      {this.state.Mounth[key] && this.state.Mounth[key].length > 0 && this.state.Mounth[key].map((item, index) => {
                        return (
                          <ToggleButton style={{ width: 20, direction: 'rtl', color: (item.weekName == "5" || item.free) && "red" }} checked={this.state.selectedDay.indexOf(item.day) !== -1} 
                           disabled={(this.state.reservedDays.filter((iii)=>{return iii == item.day}).length - this.state.originalSelectedDay.filter((iii)=>{return iii == item.day}).length) >= item.maxCapacity}
                           offLabel={item.label} onLabel={item.label} onChange={(e) => {
                            item.checked = e.value
                            console.log(this.state.originalSelectedDay)

                            let selectedDay = this.state.selectedDay;
                            if (e.value)
                              selectedDay.push(item.day);
                            else {
                              selectedDay.splice(selectedDay.indexOf(item.day), 1)
                            }

                            this.setState({
                              selectedDay: selectedDay
                            })
                            this.getDayTurns(selectedDay);
                          }
                          } />
                        )

                      })}
                    </div>
                    </div>
                  </div>

                )
              })}
              

            </div>
            <div style={{marginTop:50}} >
              <p>مجموع تعداد نوبت های امروز : {this.state.CounterListLength || 0}</p>
            <div  style={{display:'flex',justifyContent:'space-around',flexWrap:'nowrap',height:50}} >
              {this.state.CounterList.map((item, index)=>{
                return(
                  item[0] ? 
                <Tag
                  style={{marginBottom:5}}
                  severity={tagStatus[index]||"info"}
                  value={
                      <div style={{fontSize:15}}>
                        <span>{item[0].name} </span><span style={{paddingRight:4}}>{item.morning ? `( صبح :${item.morning} )` : ''}</span><span style={{paddingRight:4}}>{item.evening ? `( عصر :${item.evening} )` : ''}</span><span style={{paddingRight:4}}>{item.night ? `( شب :${item.night} )` : ''}</span>
                      </div>
                      
                    
                    
                  }
                ></Tag>
                  :
                  null
                  
                )
              })}
              </div>
            </div>
            <div className="row" style={{ alignItems: "baseline" }}>
             
              <div className="col-lg-6 col-12">
                <div className="group">
                  <input
                    className="form-control irsans"
                    value={this.state.name}
                    onChange={(e) =>
                      this.setState({
                        name: e.target.value,
                      })
                    }
                    required="true"
                  />
                  <label>نام و نام خانوادگی</label>
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div className="group">
                  <input
                    className="form-control irsans"
                    value={this.state.nationalCode}
                    onChange={(e) =>
                      this.setState({
                        nationalCode: e.target.value,
                      })
                    }
                    required="true"
                  />
                  <label>کد ملی</label>
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div className="group">
                  <input
                    className="form-control irsans"
                    value={this.state.mobile}
                    onChange={(e) =>
                      this.setState({
                        mobile: e.target.value,
                      })
                    }
                    required="true"
                  />
                  <label>تلفن همراه</label>
                </div>
              </div>
              {this.state.Settings && this.state.Settings.usersList &&
                  <div className="col-lg-6 col-12">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                        className="group"
                      >
                        <select
                          className="form-control irsans"
                          value={this.state.Counter}
                          onChange={(event) => {
                            this.setState({
                              Counter: event.target.value,
                            });
                          }}
                        >
                          <option value=""></option>
                          {this.state.Settings.usersList.map(function (u, j) {
                            return <option value={u.username}>{u.title}</option>;
                          })}
                        </select>

                        <label className="irsans">کاربران (باجه)</label>
                      </div>
                  </div>
              }
              <div className="col-lg-6 col-12">
                <div className=" mt-4">
                  <SelectButton
                    optionLabel="label"
                    optionValue="value"
                    value={this.state.Time}
                    options={TimeOptions}
                    onChange={(e) => {
                      this.setState({
                        Time: e.value,
                      });
                    }}
                  ></SelectButton>
                </div>
              </div>

              
            </div>
          </form>
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(TurnRating);
